(() => {
  'use strict';

  const aboutRoot = document.querySelector('.cgab-about');
  const whyRoot = document.querySelector('.cgau-why2');
  const pageRoot = aboutRoot || whyRoot;
  if (!pageRoot || pageRoot.querySelector('[data-cgau-dispatch-story]')) return;

  const marker = aboutRoot
    ? aboutRoot.querySelector('.cgab-story')
    : whyRoot.querySelector('.cgau-why2__human');
  if (!marker) return;

  const story = document.createElement('section');
  story.className = 'cg-dispatch-story';
  story.dataset.cgauDispatchStory = '';
  story.setAttribute('aria-labelledby', 'cg-dispatch-story-title');
  story.innerHTML = `
    <div class="cg-dispatch-story__inner">
      <header class="cg-dispatch-story__head">
        <div><p class="cg-dispatch-story__kicker">A short route through the work</p><h2 id="cg-dispatch-story-title">From the question to the front door.</h2></div>
        <p>Three ordinary steps connect a useful recommendation in Townsville with the Australian home it is meant to suit.</p>
      </header>
      <div class="cg-dispatch-story__route" aria-hidden="true">
        <svg viewBox="0 0 1000 150" role="presentation">
          <path class="cg-dispatch-story__route-line" d="M36 82 C202 23 326 132 493 79 S780 29 935 79"></path>
          <path class="cg-dispatch-story__route-path" pathLength="1" d="M36 82 C202 23 326 132 493 79 S780 29 935 79"></path>
          <circle class="cg-dispatch-story__route-pin" cx="36" cy="82" r="10"></circle>
          <path class="cg-dispatch-story__route-home" d="M914 78 950 49 986 78v48h-72zM941 126V91h19v35"></path>
        </svg>
        <div class="cg-dispatch-story__route-labels"><span>Townsville, Queensland</span><span>An Australian home</span></div>
      </div>
      <ol class="cg-dispatch-story__scenes">
        <li class="cg-dispatch-story__scene">
          <span class="cg-dispatch-story__step" data-step="1">Choose for the place</span>
          <span class="cg-dispatch-story__object cg-dispatch-story__object--choose" aria-hidden="true"></span>
          <h3>Start with the job.</h3>
          <p>The doorway, driveway, power, existing eufy gear and required hub narrow the choices. If the fit is uncertain, ask before checkout.</p>
        </li>
        <li class="cg-dispatch-story__scene">
          <span class="cg-dispatch-story__step" data-step="2">Pack the listed order</span>
          <span class="cg-dispatch-story__object cg-dispatch-story__object--pack" aria-hidden="true"></span>
          <h3>Keep the facts attached.</h3>
          <p>After checkout, the order becomes a parcel for dispatch from Townsville. The product page still controls its stated condition, packaging and included items.</p>
        </li>
        <li class="cg-dispatch-story__scene">
          <span class="cg-dispatch-story__step" data-step="3">Help when it is needed</span>
          <span class="cg-dispatch-story__object cg-dispatch-story__object--help" aria-hidden="true"></span>
          <h3>Keep the question human.</h3>
          <p>Compatibility and support questions come back to CamGuard Australia in Townsville. Tell us what gear you have and what you need to see.</p>
          <a href="/pages/contact">Ask CamGuard Australia for help</a>
        </li>
      </ol>
      <p class="cg-dispatch-story__qualification">This is a brand illustration, not a live shipment tracker or delivery timeline. We do our best to get orders out the same day. Same-day to one business day is our typical dispatch time; during busy periods it can take longer, though that is rare.</p>
    </div>`;

  marker.insertAdjacentElement('afterend', story);

  const scenes = [...story.querySelectorAll('.cg-dispatch-story__scene')];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  let sceneObserver;
  let routeObserver;

  function revealAll() {
    story.classList.add('is-route-ready');
    scenes.forEach(scene => scene.classList.add('is-visible'));
    sceneObserver?.disconnect();
    routeObserver?.disconnect();
  }

  if (reduced.matches || !('IntersectionObserver' in window)) {
    revealAll();
  } else {
    story.classList.add('is-enhanced');
    sceneObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        sceneObserver.unobserve(entry.target);
      });
    }, {threshold: .18, rootMargin: '0px 0px -7%'});
    scenes.forEach(scene => sceneObserver.observe(scene));

    routeObserver = new IntersectionObserver(entries => {
      if (!entries.some(entry => entry.isIntersecting)) return;
      story.classList.add('is-route-ready');
      routeObserver.disconnect();
    }, {threshold: .2});
    routeObserver.observe(story.querySelector('.cg-dispatch-story__route'));
  }

  const finishIfHidden = () => {
    if (document.hidden || reduced.matches) {
      story.classList.add('is-motion-stopped');
      revealAll();
    }
  };
  document.addEventListener('visibilitychange', finishIfHidden, {passive: true});
  reduced.addEventListener?.('change', finishIfHidden);
  window.addEventListener('pagehide', () => {
    sceneObserver?.disconnect();
    routeObserver?.disconnect();
    document.removeEventListener('visibilitychange', finishIfHidden);
    reduced.removeEventListener?.('change', finishIfHidden);
  }, {once: true});
})();
